document.addEventListener('DOMContentLoaded', () => {
  /* === Animaciones del footer === */
  const pies = document.querySelectorAll('.rojopie, .amarillopie');
  if (pies.length) {
    const ioPies = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('run');
          ioPies.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    pies.forEach(el => ioPies.observe(el));
  }

  /* === Animaciones del encabezado === */
  const topBars = document.querySelectorAll('.hdt-top-bar');
  const topSections = document.querySelectorAll('.hdt-top-bar-section');

  const ioHeader = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('run');
        ioHeader.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: "150px 0px 0px 0px" });

  topBars.forEach(el => ioHeader.observe(el));
  topSections.forEach(el => ioHeader.observe(el));
});


document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector(".hdt-heading-template");
  if (!container) return; // ✅ si no existe, no se activa nada

  const img = container.querySelector("img");
  const maxScroll = 300;

  window.addEventListener("scroll", () => {
    const scrollY = window.scrollY;

    const radius = Math.min((scrollY / maxScroll) * 50, 50);
    const scale  = Math.max(100 - (scrollY / maxScroll) * 1, 99);

    // Bordes y escala
    container.style.borderBottomLeftRadius  = `${radius}px`;
    container.style.borderBottomRightRadius = `${radius}px`;
    container.style.borderTopLeftRadius     = `${radius}px`;
    container.style.borderTopRightRadius    = `${radius}px`;
    container.style.width = `${scale}%`;

    // Parallax en la imagen
    if (img) {
      img.style.setProperty('transform', `translateY(${scrollY * 0.25 - 30}px)`, 'important');
      img.style.transition = "transform 0.2s ease-out";
      img.style.height = "120%";
      img.style.objectFit = "cover";
    }

    // Transiciones suaves del contenedor
    container.style.transition = "border-radius 0.2s ease-out, width 0.2s ease-out";
  }, { passive: true });
});


(function () {
  const observer = new MutationObserver(function (mutations, obs) {
    const btn = document.querySelector('.hdt-mobile-tab-btn[data-tab="categories"]');
    if (btn) {
      btn.textContent = 'CATEGORÍAS';
      obs.disconnect(); // 👈 se apaga solo
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();







